<template>
    <div class="d-flex flex-wrap align-center py-4">
        <p class="text-h3 mr-2 font-weight-bold align-center">{{ travelCardName }}</p>
        <p class="text-h3 font-weight-light mr-3">{{ travelCardNumber }}</p>
        <v-chip v-if="isTravelCardBlocked" size="small" color="warning">
            <svg-icon :icon="info" alt="info" />
            <p class="text-h3 font-weight-medium text-secondary-light ml-2 text-size-xs">{{ t('travelCard.blockingStatusInProgress') }}</p>
        </v-chip>
    </div>
</template>

<script setup lang="ts">
import { ITicketCardHeader } from '../../types';
import { useI18n } from 'vue-i18n';
import info from '@/assets/info.svg';
import SvgIcon from '@/features/common/components/SvgIcon.vue';

const { t } = useI18n();
defineProps<ITicketCardHeader>();
</script>
